import { render } from "./MyFavorites.vue?vue&type=template&id=502ba770&scoped=true"
import script from "./MyFavorites.vue?vue&type=script&lang=js"
export * from "./MyFavorites.vue?vue&type=script&lang=js"

import "./MyFavorites.vue?vue&type=style&index=0&id=502ba770&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502ba770"]])

export default __exports__